import React, { FC, useEffect } from 'react';

import { useParams, RouteProps, useHistory } from 'react-router-dom';
import { batch, useDispatch, useSelector } from 'react-redux'

import { SolicitacaoFormulario } from 'view/section/SolicitacaoFormulario/SolicitacaoFormulario';

import { FormikDebug } from 'view/component/Formulario/FormikDebug';
import { SolicitacaoFormularioContexto } from 'view/section/SolicitacaoFormularioContexto/SolicitacaoFormularioContexto';
import { InformacoesPersistencia } from 'view/page/SolicitacaoServicoPage/InformacoesPersistencia';
import { Conteudo } from 'view/section/Conteudo/Conteudo';

import { SolicitacaoResumida } from 'model/solicitacao/SolicitacaoResumida';
import { SolicitacaoDetalhada, SolicitacaoDetalhadaCadastroFormulario } from 'model/solicitacao/SolicitacaoDetalhada';
import { AtividadesSolicitacao } from './AtividadesSolicitacao';
import { SolicitacaoServicoPageHeader } from './header/SolicitacaoServicoPageHeader';
import { SolicitacaoServicoPageBreadcrumbs } from './SolicitacaoServicoPageBreadcrumbs';
import { SolicitacaoServicoPageFormularioFooter } from './formulario/SolicitacaoServicoPageFormularioFooter';

import { SolicitacaoCorrenteAction } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.action';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';
import { SolicitacaoCorrenteAcao } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.types';

import { toIntOrUndefined } from 'util/javascript';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';
import { SolicitacaoServicoPageFormulario } from './formulario/SolicitacaoServicoPageFormulario';

import { RestricoesSolicitacaoServicoFormulario } from 'business/formulario/RestricoesSolicitacaoServicoFormulario';
import { useRestricoesFormulario } from 'service/restricao/useRestricoesFormulario/useRestricoesFormulario';
import { OperacaoFormularioCRUD } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import './solicitacao-servico-page.scss'
import { If } from 'view/component/Utils/If';
import { AppDispatch, useAppDispatch } from 'store/store';
import { AvaliacaoAction } from 'store/Avaliacao/Avaliacao.action';


interface QueryParams {
  id?: string;
}


export const SolicitacaoServicoPage: FC<RouteProps> = (props) => {
  const { id: idString } = useParams<QueryParams>();
  const id = toIntOrUndefined(idString);

  const solicitacaoResumida = props.location?.state as SolicitacaoResumida|undefined;
  const solicitacaoCorrente = useSelector(SolicitacaoCorrenteSelector.solicitacao);
  
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (id === undefined) {
      dispatch(SolicitacaoCorrenteAction.criacao.iniciar())
    } else {
      dispatch(SolicitacaoServicoPageAction.carregarSolicitacao(id, solicitacaoResumida));
    }
  }, [id, solicitacaoResumida, dispatch]);

  return <SolicitacaoServicoPageView idSolicitacao={id} solicitacao={solicitacaoCorrente} />
}


export interface SolicitacaoServicoPageViewProps extends React.HTMLAttributes<HTMLDivElement> {
  idSolicitacao?: number
  solicitacao: SolicitacaoDetalhada
}

export const SolicitacaoServicoPageView: FC<SolicitacaoServicoPageViewProps> = ({idSolicitacao, solicitacao}) => {
  const restricoes = useRestricoesFormulario(RestricoesSolicitacaoServicoFormulario);

  const dispatch = useAppDispatch();

  const history = useHistory();

  const operacao = useSelector(SolicitacaoCorrenteSelector.formulario.operacao);
  const acao = useSelector(SolicitacaoCorrenteSelector.formulario.acao);
  const carregando = useSelector(SolicitacaoCorrenteSelector.formulario.isCarregando);
  const erros = useSelector(SolicitacaoCorrenteSelector.formulario.erros);

  const hasErros = useSelector(SolicitacaoCorrenteSelector.formulario.hasErros);
  const ocultarEmCasoDeErroNaVisualizacao =
       operacao === OperacaoFormularioCRUD.Visualizar 
    && acao === SolicitacaoCorrenteAcao.Visualizar
    && hasErros;

  const exibirTentarNovamente = ocultarEmCasoDeErroNaVisualizacao;
  const tentarNovamente = exibirTentarNovamente
    ? () => dispatch(tentarCarregarSolicitacaoNovamente(solicitacao))
    : undefined;
  
  const submit = async (solicitacaoAtualizada: SolicitacaoDetalhadaCadastroFormulario) => {
    if (operacao === OperacaoFormularioCRUD.Criar) {
      const solicitacaoPersistida = await dispatch(SolicitacaoCorrenteAction.criacao.persistir(solicitacaoAtualizada)).unwrap();
      history.push(`${solicitacaoPersistida.id}`, solicitacaoPersistida);

    } else {
      return await dispatch(SolicitacaoCorrenteAction.edicao.persistir(solicitacaoAtualizada, solicitacao, restricoes));
    }
  }

  return (
    <>
      <SolicitacaoServicoPageBreadcrumbs idSolicitacao={idSolicitacao} solicitacao={solicitacao} />

      <Conteudo>
        <SolicitacaoServicoPageFormulario
          solicitacao={solicitacao}
          onSubmit={submit}>
          <If condicao={!ocultarEmCasoDeErroNaVisualizacao}>
            <SolicitacaoServicoPageHeader
              idSolicitacao={idSolicitacao}
              solicitacao={solicitacao}
              className="header"
              />
          </If>

          <section className="centro">
            <MensagensErroServidor className="erros" erro={erros} retry={tentarNovamente} />
            <If condicao={!ocultarEmCasoDeErroNaVisualizacao}>
              <SolicitacaoFormulario solicitacao={solicitacao} />
            </If>
          </section>

          <If condicao={!ocultarEmCasoDeErroNaVisualizacao}>
            <aside className="barra-lateral">
              <SolicitacaoFormularioContexto solicitacao={solicitacao} />
              <InformacoesPersistencia solicitacao={solicitacao} />
            </aside>
            <SolicitacaoServicoPageFormularioFooter className="rodape-formulario" />
          </If>
          <FormikDebug />
        </SolicitacaoServicoPageFormulario>

        <If condicao={!ocultarEmCasoDeErroNaVisualizacao && idSolicitacao !== undefined}>
          <AtividadesSolicitacao loading={carregando} solicitacao={solicitacao} />
        </If>
      </Conteudo>
    </>
  )
}


function tentarCarregarSolicitacaoNovamente(solicitacao: SolicitacaoResumida) {
  const mensagem = {
    idSolicitacao: solicitacao.id,
    solicitacao: solicitacao
  }

  return SolicitacaoCorrenteAction.visualizacao.carregar(mensagem);
}


export class SolicitacaoServicoPageAction {
  static carregarSolicitacao(id: number, solicitacao?: SolicitacaoResumida) {
    return async (dispatch: AppDispatch) => {
      return batch(() => {
        dispatch(SolicitacaoCorrenteAction.visualizacao.carregar({idSolicitacao: id, solicitacao: solicitacao}));
        dispatch(AvaliacaoAction.lista.iniciar());
      })
    }
  }
}
